<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.account"
        :primary-fields="[ 'name', 'carrier_settings.charge_account', 'parent', 'carrier_settings.carrier', 'status' ]"
        @apply="reload"
        @ready="load"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        v-loading="isLoading"
        shadow="never"
      >
        <AccountsTable :accounts="accounts">
          <template v-slot:peek="{ account }">
            <AccountPeek :account="account" />
          </template>
        </AccountsTable>

        <el-pagination
          class="text-center pt-3"
          :current-page.sync="accounts.page"
          :page-size.sync="accounts.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="accounts.total"
          @size-change="reload"
          @current-change="reload"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import AccountsTable from '@/components/Application/CustomerService/Accounts/Table'
import AccountPeek from '@/components/Application/CustomerService/Accounts/Account/Peek'

export default {
  components: {
    Filters,
    AccountsTable,
    AccountPeek
  },
  data () {
    return {
      title: 'Accounts',
      actions: [
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: this.reload
        }
      ],
      isLoading: true,
      filters: [],
      accounts: []
    }
  },
  methods: {
    async load () {
      this.isLoading = true

      this.accounts = await this
        .$sdk
        .account
        .list(request => {
          request.include = [ 'account_manager', 'b_group', 'parent' ]
          request.filters = this.filters
        })

      this.isLoading = false
    },
    async reload () {
      this.isLoading = true

      await this
        .accounts
        .reload(request => {
          request.filters = this.filters
        })

      this.isLoading = false
    }
  }
}
</script>
